module.exports = __webpack_public_path__ + "img/youbeibobao@2x.23935735.png";